import React, { useEffect, useCallback, useRef } from 'react';
import { InputGroup, InputLeftElement, Input } from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import colors from "common/theme/foundations/colors";
const LocalSearch = React.memo(({
  allData,
  setSearchbox,
  setDisplaySearchData,
  searchbox,
  dataColumn,
  onSearch,
  setGetTagValues,
  setGopageValue,

  isKanban = false,
  source = ''

}) => {
  const debounceTimeout = useRef(null);

  useEffect(() => {
    const savedSearchTerm = localStorage.getItem('searchTerm');
    if (savedSearchTerm) {
      setSearchbox(savedSearchTerm);
    }
  }, [setSearchbox]);

  const handleInputChange = useCallback((e) => {
    const originalValue = e.target.value; 
    const searchTerm = originalValue.toLowerCase(); 
    setSearchbox(originalValue);

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      const results = allData.filter((item) => {
        return dataColumn.some((column) => {
          const columnValue = item[column.accessor];
          if (typeof columnValue === 'string') {
            return columnValue.toLowerCase().includes(searchTerm); 
          }
          if (typeof columnValue === 'number') {
            return columnValue.toString().includes(searchTerm);
          }
          return false;
        });
      });

      setDisplaySearchData(searchTerm !== '');
      onSearch(results);
      setGetTagValues([]);

      if (searchTerm === '' && setGopageValue) {
        setGopageValue(1);
      }
    }, 300); 
  }, [allData, dataColumn, onSearch, setSearchbox, setDisplaySearchData, setGetTagValues, setGopageValue]);

  return (
    <InputGroup
      width={'100%'}
      maxWidth={'251px'}
      mx={{ sm: 0, md: 3 }}
      my={{ sm: "8px", md: "0" }}
      className="search-input"
    >
      <InputLeftElement
        size="sm"
        top="-3px"
        pointerEvents="none"
        zIndex="0"
        children={
          <SearchIcon  className="customSearchIcon" color={colors.iconDark} />
        }
      />
      <Input
        type="text"
        size="sm"
        fontSize="sm"
        value={searchbox}
        onChange={handleInputChange}
        fontWeight="400"
        placeholder="Search"
        borderRadius="16px"
      />
    </InputGroup>
  );
});

export default LocalSearch;